import { ActivatedRouteSnapshot, ResolveFn, Router } from '@angular/router';
import { WwwDirectusService } from 'www-cms';
import { inject } from '@angular/core';
import { catchError, EMPTY, switchMap } from 'rxjs';
import { Store } from '@ngxs/store';
import { PageActions } from './state/page.actions';

export const pageResolver: ResolveFn<void> = (
  route: ActivatedRouteSnapshot
) => {
  if (!route.data['id']) {
    throw new Error('Page resolver requires an id');
  }
  const store = inject(Store);
  const router = inject(Router);
  // We don't want versioned pages to be cached, so only get the versioned page if viewing with preview mode enabled (which disables caching)
  const version =
    route.queryParamMap.get('version') &&
    route.queryParamMap.get('preview') === 'true'
      ? route.queryParamMap.get('version')!
      : undefined;

  return inject(WwwDirectusService)
    .getPage(route.data['id'], version)
    .pipe(
      catchError(() => {
        router.navigate(['/not-found']);
        return EMPTY;
      }),
      switchMap((page) => store.dispatch(new PageActions.SetPage(page)))
    );
};
